import classnames from 'classnames/bind';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';

import { ApplicationParams } from 'types/route_params';
import { DeployRoute, MonitorRoute, NavRoute } from 'application/types/routes';

import { Dashboards } from 'dashboards/views';

import { FilesSearch } from 'files/views/Search/Search';
import { Heading } from 'components/Heading/Heading';
import { NotFound } from 'views/NotFound/NotFound';
import { Separator } from 'components/Separator/Separator';
import { Sidebar } from 'components/Sidebar/Sidebar';
import { SidebarLink } from 'components/Sidebar/SidebarLink';

import { MonitorDashboardLinks } from './DashboardLinks';
import styles from './Monitor.module.scss';
import { useCurrentPlan } from 'organizations/hooks/useCurrentPlan';
import { useModal } from 'hooks/useModal';
import { Button } from 'components/Button/Button';

const c = classnames.bind(styles);

export function Monitor() {
  const { applicationID } = useParams<ApplicationParams>();
  const { data: currentPlan } = useCurrentPlan();
  const { open } = useModal();
  const canSearch = currentPlan && currentPlan.can_search;

  const defaultRoute = canSearch
    ? MonitorRoute.SEARCH
    : MonitorRoute.DASHBOARDS;

  return (
    <div className={c('monitor')}>
      <Sidebar>
        <Heading level="4">Recordings</Heading>
        <SidebarLink
          to={`/${NavRoute.MONITOR}/${MonitorRoute.SEARCH}`}
          icon="search"
        >
          Search recordings
        </SidebarLink>

        <Separator />

        <li className={c('sidebar-scroll')}>
          <Heading level="4">Dashboards</Heading>

          {/* TODO: Search */}

          <MonitorDashboardLinks />
        </li>

        <Button
          onClick={() => open('create-dashboard')}
          variant="primary"
          size="small"
        >
          Create Dashboard
        </Button>
      </Sidebar>

      <Routes>
        <Route index element={<Navigate to={defaultRoute} replace />} />

        <Route
          path="events"
          element={
            <Navigate
              to={`/applications/${applicationID}/${NavRoute.DEPLOY}/${DeployRoute.EVENTS}`}
            />
          }
        />

        <Route path="dashboards/*" element={<Dashboards />} />

        <Route path="search" element={<FilesSearch />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}
